module.exports = __webpack_public_path__ + "static/media/product_15.47bea8c0.jpg";